package com.artvending.warden.screens.success

import androidx.compose.runtime.Composable
import com.artvending.warden.Card
import com.artvending.warden.Column_
import com.artvending.warden.OutlinedButton
import com.artvending.warden.Row_
import com.artvending.warden.goHome
import com.artvending.warden.settings
import com.artvending.warden.language
import com.artvending.warden.log
import org.jetbrains.compose.web.attributes.Draggable
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
actual fun Any?.SuccessScreen(model: SuccessScreenModel) {
	Div({ style { flexGrow(1) } })
	Column_({ style { flexGrow(1); alignSelf(AlignSelf.Stretch); gap(settings.bigSpace) } }) {
		log("SuccessScreen()--------------")
		Div({ classes(settings.headlineFontClass); style { textAlign("center") } }) {
			Text(language.DONE)
		}
		Card {
			Row_({ style { gap(settings.space) } }) {
				Img("done.svg", language.DONE) { draggable(Draggable.False); style { width(settings.imageSize); alignSelf(AlignSelf.Center) } }
				Div({ style { width(1.px); backgroundColor(settings.opacityLightGray); margin(-settings.space, 0.px); alignSelf(AlignSelf.Stretch) } })
				Column_({ style { flexGrow(1); alignSelf(AlignSelf.Center); textAlign("center") } }) {
					Span({ style { color(settings.opacityGray) } }) {
						Text(language.FIX_TIME)
					}
					Span({ classes(settings.displayFontClass); style { fontWeight("bold") } }) {
						Text("${model.dateTime!!.hour}:${model.dateTime.minute.toString().padStart(2, '0')}")
					}
				}
			}
		}
		OutlinedButton({ goHome() }, { style { alignSelf(AlignSelf.Center); marginTop(settings.space) } }) {
			Text(language.BACK)
		}
	}
	Div({ style { flexGrow(1.5) } })
}